module.exports = __webpack_public_path__ + "img/icon-tab-3.b14645f8.svg";